import { AxiosRequestConfig, AxiosResponse } from 'axios';

import AbstractCRMApi from '../../AbstractCRMApi';
import Article from '../../Models/Article';
import GetArticleResponse from '../Responses/ArticleResponse';
import GetPaginatedResponse from '../Responses/PaginatedResponse';

import { SelectOptions } from 'crm/elements/formElements/Select';
import { formatArticleTranslations } from 'crm/helpers/formUtils';

class ArticlesApi extends AbstractCRMApi {
    public endpoint: string = 'article';

    public getById(id: number): Promise<Article> {
        return this.get(`/${id}`).then((response: AxiosResponse<GetArticleResponse>) =>
            ArticlesApi.mapDataToArticleClass(response.data)
        );
    }

    public getArticles(page: number = 1, config?: AxiosRequestConfig): Promise<GetPaginatedResponse<Article>> {
        return this.get('', {
            ...config,
            params: { ...config?.params, page },
        }).then((response: AxiosResponse<GetPaginatedResponse>) => {
            return AbstractCRMApi.mapPaginatedDataToModel(response.data, Article);
        });
    }

    public getPartials(page: number = 1, config: AxiosRequestConfig = {}): Promise<GetPaginatedResponse<Article>> {
        return this.get('/partials', {
            ...config,
            params: { ...config?.params, page },
        }).then((response: AxiosResponse<GetPaginatedResponse>) => {
            return AbstractCRMApi.mapPaginatedDataToModel(response.data, Article);
        });
    }

    public store(article: Article): Promise<Article> {
        return this.post('', article).then((response: AxiosResponse<GetArticleResponse>) =>
            ArticlesApi.mapDataToArticleClass(response.data)
        );
    }

    public update(article: Article): Promise<Article> {
        return this.patch(`/${article.id}`, article).then((response: AxiosResponse<GetArticleResponse>) =>
            ArticlesApi.mapDataToArticleClass(response.data)
        );
    }

    public async getTranslations(partials: boolean): Promise<SelectOptions> {
        return formatArticleTranslations(
            (
                await this.get('/translations', {
                    params: {
                        partials: +partials,
                    },
                })
            ).data
        );
    }

    public getByTranslationIdAndLanguageId(translationId: number, languageId: number): Promise<Article> {
        return this.get(
            `/translation/${translationId}/language/${languageId}`
        ).then((response: AxiosResponse<GetArticleResponse>) => ArticlesApi.mapDataToArticleClass(response.data));
    }
}

export default new ArticlesApi();
